(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["akb-brand-list"] && !Shopify.designMode) return;
  try {
    
  function initBrandCarousel(root) {
    if (!root || root.dataset.brandReady === 'true') return;
    const viewport = root.querySelector('.brand-carousel__viewport');
    const track = root.querySelector('.brand-carousel__track');
    const dotsContainer = root.querySelector('.brand-carousel__dots');
    if (!track || !viewport) return;

    const items = Array.from(track.children);
    if (items.length === 0) return;

    root.dataset.brandReady = 'true';
    let index = 0;
    let timer = 0;

    const getPerPage = () => {
      const w = viewport.clientWidth || window.innerWidth;
      if (w < 520) return 2;
      if (w < 768) return 3;
      if (w < 1040) return 4;
      return 6;
    };

    let perPage = getPerPage();
    let pages = Math.max(1, Math.ceil(items.length / perPage));

    const renderDots = () => {
      if (!dotsContainer) return;
      dotsContainer.innerHTML = '';
      if (pages <= 1) {
        dotsContainer.style.display = 'none';
        return;
      }
      dotsContainer.style.display = 'flex';
      for (let i = 0; i < pages; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.dataset.brandDot = '';
        dot.setAttribute('aria-label', 'Slide ' + (i + 1) + ' of ' + pages);
        if (i === index) dot.setAttribute('aria-current', 'true');
        dot.addEventListener('click', () => {
          show(i);
          start();
        });
        dotsContainer.appendChild(dot);
      }
    };

    const layout = () => {
      const newPerPage = getPerPage();
      if (newPerPage !== perPage) {
        perPage = newPerPage;
        pages = Math.max(1, Math.ceil(items.length / perPage));
        if (index >= pages) index = Math.max(0, pages - 1);
        renderDots();
      }
      const itemWidth = viewport.clientWidth / perPage;
      items.forEach((el) => {
        el.style.flex = '0 0 ' + itemWidth + 'px';
        el.style.width = itemWidth + 'px';
      });
      track.style.transform = 'translateX(-' + index * viewport.clientWidth + 'px)';
    };

    const show = (nextIndex) => {
      index = (nextIndex + pages) % pages;
      track.style.transform = 'translateX(-' + index * viewport.clientWidth + 'px)';
      const dots = Array.from(root.querySelectorAll('[data-brand-dot]'));
      dots.forEach((dot, i) => {
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    const stop = () => {
      if (timer) {
        window.clearInterval(timer);
        timer = 0;
      }
    };

    const start = () => {
      stop();
      if (pages < 2) return;
      timer = window.setInterval(() => show(index + 1), 4500);
    };

    // Touch swipe support
    let touchStartX = 0;
    let touchStartY = 0;
    viewport.addEventListener('touchstart', (e) => {
      stop();
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
    }, { passive: true });

    viewport.addEventListener('touchend', (e) => {
      const endX = e.changedTouches[0].screenX;
      const endY = e.changedTouches[0].screenY;
      const diffX = touchStartX - endX;
      const diffY = touchStartY - endY;
      if (Math.abs(diffX) > 40 && Math.abs(diffX) > Math.abs(diffY)) {
        if (diffX > 0) show(index + 1);
        else show(index - 1);
      }
      start();
    }, { passive: true });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    window.addEventListener('resize', layout);

    renderDots();
    layout();
    start();
  }

  document.querySelectorAll('[data-brand-carousel]').forEach(initBrandCarousel);
  document.querySelectorAll('.brand-carousel').forEach((root) => {
    if (!root.hasAttribute('data-brand-carousel')) initBrandCarousel(root);
  });
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('.brand-carousel');
    if (root) initBrandCarousel(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["akb-contact"] && !Shopify.designMode) return;
  try {
    
  const field = document.querySelector('[data-akb-query-product]');
  if (field) {
    const params = new URLSearchParams(window.location.search);
    const value = params.get('product') || params.get('sku') || '';
    if (value) field.value = value;
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["akb-featured-products"] && !Shopify.designMode) return;
  try {
    
  function initProductCarousel(root) {
    if (!root || root.dataset.productReady === 'true') return;

    const viewport = root.querySelector('.product-carousel__viewport');
    const track = root.querySelector('.product-carousel__track');
    const dotsContainer = root.querySelector('[data-product-dots]');
    if (!viewport || !track) return;

    const items = Array.from(track.children);
    if (items.length === 0) return;

    root.dataset.productReady = 'true';

    const maxCols = Number(root.dataset.columns) || 5;
    const interval = Number(root.dataset.interval) || 5000;
    const autoplay = root.dataset.autoplay === 'true';
    const slideLabel = root.dataset.slideLabel || 'Show products __index__ of __count__';
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let index = 0;
    let timer = 0;

    // Mirrors the .pgrid breakpoints in akb-storefront.css
    const getPerPage = () => {
      const w = window.innerWidth;
      let base = maxCols;
      if (w < 460) base = 1;
      else if (w < 760) base = 2;
      else if (w < 1080) base = 3;
      return Math.max(1, Math.min(base, maxCols));
    };

    let perPage = getPerPage();
    let pages = Math.max(1, Math.ceil(items.length / perPage));

    const show = (nextIndex) => {
      index = (nextIndex + pages) % pages;
      track.style.transform = 'translateX(-' + index * viewport.clientWidth + 'px)';
      Array.from(root.querySelectorAll('[data-product-dot]')).forEach((dot, i) => {
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    const stop = () => {
      if (timer) {
        window.clearInterval(timer);
        timer = 0;
      }
    };

    const start = () => {
      stop();
      if (!autoplay || reduceMotion || pages < 2) return;
      timer = window.setInterval(() => show(index + 1), interval);
    };

    const renderDots = () => {
      if (!dotsContainer) return;
      dotsContainer.innerHTML = '';
      if (pages < 2) {
        dotsContainer.style.display = 'none';
        return;
      }
      dotsContainer.style.display = 'flex';
      for (let i = 0; i < pages; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.dataset.productDot = '';
        dot.setAttribute(
          'aria-label',
          slideLabel.replace('__index__', String(i + 1)).replace('__count__', String(pages))
        );
        if (i === index) dot.setAttribute('aria-current', 'true');
        dot.addEventListener('click', () => {
          show(i);
          start();
        });
        dotsContainer.appendChild(dot);
      }
    };

    const layout = () => {
      const nextPerPage = getPerPage();
      if (nextPerPage !== perPage) {
        perPage = nextPerPage;
        pages = Math.max(1, Math.ceil(items.length / perPage));
        if (index >= pages) index = Math.max(0, pages - 1);
        renderDots();
        start();
      }
      const itemWidth = viewport.clientWidth / perPage;
      items.forEach((el) => {
        el.style.flex = '0 0 ' + itemWidth + 'px';
        el.style.maxWidth = itemWidth + 'px';
      });
      track.style.transform = 'translateX(-' + index * viewport.clientWidth + 'px)';
    };

    let touchStartX = 0;
    let touchStartY = 0;
    viewport.addEventListener('touchstart', (event) => {
      stop();
      touchStartX = event.changedTouches[0].screenX;
      touchStartY = event.changedTouches[0].screenY;
    }, { passive: true });

    viewport.addEventListener('touchend', (event) => {
      const diffX = touchStartX - event.changedTouches[0].screenX;
      const diffY = touchStartY - event.changedTouches[0].screenY;
      if (Math.abs(diffX) > 40 && Math.abs(diffX) > Math.abs(diffY)) {
        if (diffX > 0) show(index + 1);
        else show(index - 1);
      }
      start();
    }, { passive: true });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', (event) => {
      if (!root.contains(event.relatedTarget)) start();
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
      else start();
    });

    window.addEventListener('resize', layout);

    renderDots();
    layout();
    start();
  }

  document.querySelectorAll('[data-product-carousel]').forEach(initProductCarousel);
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-product-carousel]');
    if (root) initProductCarousel(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["akb-featured-spotlight"] && !Shopify.designMode) return;
  try {
    
  const spotlightCarousels = new Map();

  function initSpotlightCarousel(root) {
    if (!root || spotlightCarousels.has(root)) return;

    const slides = Array.from(root.querySelectorAll('[data-spotlight-slide]'));
    if (!slides.length) return;

    const dots = Array.from(root.querySelectorAll('[data-spotlight-dot]'));
    const nav = root.querySelector('.spotlight__nav');
    const previous = root.querySelector('[data-spotlight-prev]');
    const next = root.querySelector('[data-spotlight-next]');
    const pause = root.querySelector('[data-spotlight-pause]');
    const current = root.querySelector('[data-spotlight-current]');
    const status = root.querySelector('[data-spotlight-status]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const controller = new AbortController();
    const eventOptions = { signal: controller.signal };
    const autoplay = root.dataset.autoplay === 'true';
    const interval = Math.max(3000, Number(root.dataset.interval) || 5000);
    let index = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
    let timer;
    let userPaused = false;
    let requestedPlayback = false;
    let hovered = window.matchMedia('(hover: hover)').matches && root.matches(':hover');
    let focused = root.contains(document.activeElement);
    let touching = false;
    let touchStart = null;

    root.dataset.spotlightReady = 'true';
    if (nav) nav.hidden = slides.length < 2;
    if (pause) pause.hidden = !autoplay || slides.length < 2;

    function stop() {
      window.clearTimeout(timer);
      timer = undefined;
    }

    function isUserPaused() {
      return userPaused || (reducedMotion.matches && !requestedPlayback);
    }

    function updatePlayback() {
      stop();
      const showPlay = isUserPaused();
      if (pause) {
        pause.setAttribute('aria-label', showPlay ? pause.dataset.labelPlay : pause.dataset.labelPause);
        const pauseIcon = pause.querySelector('[data-spotlight-pause-icon]');
        const playIcon = pause.querySelector('[data-spotlight-play-icon]');
        if (pauseIcon) pauseIcon.toggleAttribute('hidden', showPlay);
        if (playIcon) playIcon.toggleAttribute('hidden', !showPlay);
      }

      if (!autoplay || slides.length < 2 || userPaused || document.hidden || touching) return;
      if (!requestedPlayback && (reducedMotion.matches || hovered || focused)) return;
      timer = window.setTimeout(() => goTo(index + 1), interval);
    }

    function render() {
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.toggleAttribute('inert', !active);
      });
      dots.forEach((dot, dotIndex) => {
        if (dotIndex === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (current) current.textContent = String(index + 1).padStart(2, '0');
    }

    function goTo(nextIndex, manual = false) {
      const targetIndex = ((nextIndex % slides.length) + slides.length) % slides.length;
      if (manual) requestedPlayback = false;
      if (targetIndex !== index) {
        if (slides[index].contains(document.activeElement)) root.focus({ preventScroll: true });
        index = targetIndex;
        render();
        if (manual && status) {
          const slideLabel = (root.dataset.slideLabel || '[index] / [count]')
            .replace('[index]', String(index + 1))
            .replace('[count]', String(slides.length));
          const title = slides[index].querySelector('h2')?.textContent.trim();
          status.textContent = title ? `${slideLabel}: ${title}` : slideLabel;
        }
      }
      updatePlayback();
    }

    previous?.addEventListener('click', () => goTo(index - 1, true), eventOptions);
    next?.addEventListener('click', () => goTo(index + 1, true), eventOptions);
    dots.forEach((dot, dotIndex) => {
      dot.addEventListener('click', () => goTo(dotIndex, true), eventOptions);
    });
    pause?.addEventListener('click', () => {
      const shouldPlay = isUserPaused();
      userPaused = !shouldPlay;
      requestedPlayback = shouldPlay;
      updatePlayback();
    }, eventOptions);

    root.addEventListener('pointerenter', event => {
      if (event.pointerType !== 'mouse') return;
      hovered = true;
      requestedPlayback = false;
      updatePlayback();
    }, eventOptions);
    root.addEventListener('pointerleave', event => {
      if (event.pointerType !== 'mouse') return;
      hovered = false;
      updatePlayback();
    }, eventOptions);
    root.addEventListener('focusin', event => {
      focused = true;
      if (event.target !== pause) requestedPlayback = false;
      updatePlayback();
    }, eventOptions);
    root.addEventListener('focusout', event => {
      focused = root.contains(event.relatedTarget);
      updatePlayback();
    }, eventOptions);

    root.addEventListener('keydown', event => {
      if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
      if (event.target.closest('input, textarea, select, [contenteditable="true"]')) return;
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      goTo(index + (event.key === 'ArrowRight' ? 1 : -1), true);
    }, eventOptions);

    document.addEventListener('visibilitychange', updatePlayback, eventOptions);
    reducedMotion.addEventListener('change', () => {
      requestedPlayback = false;
      updatePlayback();
    }, eventOptions);

    root.addEventListener('touchstart', event => {
      touching = true;
      if (!pause?.contains(event.target)) requestedPlayback = false;
      touchStart = event.touches.length === 1 ? {
        x: event.touches[0].clientX,
        y: event.touches[0].clientY
      } : null;
      updatePlayback();
    }, { ...eventOptions, passive: true });
    root.addEventListener('touchend', event => {
      touching = false;
      const touch = event.changedTouches[0];
      const start = touchStart;
      touchStart = null;
      if (start && touch) {
        const dx = touch.clientX - start.x;
        const dy = touch.clientY - start.y;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.25) {
          goTo(index + (dx < 0 ? 1 : -1), true);
          return;
        }
      }
      updatePlayback();
    }, { ...eventOptions, passive: true });
    root.addEventListener('touchcancel', () => {
      touching = false;
      touchStart = null;
      updatePlayback();
    }, { ...eventOptions, passive: true });

    spotlightCarousels.set(root, () => {
      stop();
      controller.abort();
      delete root.dataset.spotlightReady;
      spotlightCarousels.delete(root);
    });
    render();
    updatePlayback();
  }

  document.querySelectorAll('[data-spotlight-carousel]').forEach(initSpotlightCarousel);
  document.addEventListener('shopify:section:load', event => {
    if (event.target.matches('[data-spotlight-carousel]')) initSpotlightCarousel(event.target);
    event.target.querySelectorAll('[data-spotlight-carousel]').forEach(initSpotlightCarousel);
  });
  document.addEventListener('shopify:section:unload', event => {
    spotlightCarousels.forEach((cleanup, root) => {
      if (root === event.target || event.target.contains(root)) cleanup();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["akb-hero"] && !Shopify.designMode) return;
  try {
    
  function initHeroCarousel(root) {
    if (!root || root.dataset.heroReady === 'true') return;

    const track = root.querySelector('.hero-banner__track');
    const slides = Array.from(root.querySelectorAll('[data-hero-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-hero-dot]'));
    const prev = root.querySelector('[data-hero-prev]');
    const next = root.querySelector('[data-hero-next]');
    const pause = root.querySelector('[data-hero-pause]');
    if (!track || slides.length < 2) return;

    root.dataset.heroReady = 'true';
    let index = 0;
    let timer = 0;
    const interval = Number(root.dataset.interval) || 5000;
    const autoplay = root.dataset.autoplay === 'true';
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let paused = false;
    let hovered = false;
    let editorSelected = false;
    const lifecycle = new AbortController();
    const listenerOptions = { signal: lifecycle.signal };

    const show = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      slides.forEach((slide, i) => {
        const on = i === index;
        slide.classList.toggle('is-active', on);
        slide.setAttribute('aria-hidden', String(!on));
        if (on) slide.removeAttribute('inert');
        else slide.setAttribute('inert', '');
      });
      dots.forEach((dot, i) => {
        if (i === index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    };

    const stop = () => {
      if (timer) {
        window.clearInterval(timer);
        timer = 0;
      }
    };

    const start = () => {
      stop();
      if (!autoplay || reduceMotion || paused || hovered || editorSelected || document.hidden || root.contains(document.activeElement)) return;
      timer = window.setInterval(() => show(index + 1), interval);
    };

    if (pause) {
      pause.hidden = reduceMotion;
      pause.addEventListener('click', () => {
        paused = !paused;
        pause.setAttribute('aria-label', paused ? pause.dataset.playLabel : pause.dataset.pauseLabel);
        pause.querySelector('[data-pause-icon]').toggleAttribute('hidden', paused);
        pause.querySelector('[data-play-icon]').toggleAttribute('hidden', !paused);
        start();
      });
    }

    if (prev) prev.addEventListener('click', () => { show(index - 1); start(); });
    if (next) next.addEventListener('click', () => { show(index + 1); start(); });
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => { show(i); start(); });
    });

    root.addEventListener('mouseenter', () => { hovered = true; stop(); });
    root.addEventListener('mouseleave', () => { hovered = false; start(); });
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', (event) => {
      if (!root.contains(event.relatedTarget)) window.setTimeout(start, 0);
    });
    root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        show(index - 1);
        start();
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        show(index + 1);
        start();
      }
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
      else start();
    }, listenerOptions);

    document.addEventListener('shopify:block:select', (event) => {
      const selectedIndex = slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
      if (selectedIndex < 0) return;
      editorSelected = true;
      stop();
      show(selectedIndex);
    }, listenerOptions);

    document.addEventListener('shopify:block:deselect', (event) => {
      if (!slides.some((slide) => slide.dataset.blockId === event.detail.blockId)) return;
      editorSelected = false;
      start();
    }, listenerOptions);

    document.addEventListener('shopify:section:unload', (event) => {
      if (!event.target.contains(root)) return;
      stop();
      lifecycle.abort();
    }, listenerOptions);

    start();
  }

  document.querySelectorAll('[data-hero-carousel]').forEach(initHeroCarousel);
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-hero-carousel]');
    if (root) initHeroCarousel(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["akb-main-product"]) return;
  try {
    
  document.querySelectorAll('[data-akb-product]').forEach((section) => {
    const qtyInput = section.querySelector('input[name="quantity"]');
    section.querySelectorAll('[data-akb-qty]').forEach((button) => {
      button.addEventListener('click', () => {
        const next = Math.max(1, (Number(qtyInput.value) || 1) + Number(button.dataset.akbQty));
        qtyInput.value = String(next);
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    const thumbs = section.querySelectorAll('[data-akb-thumb]');
    const main = section.querySelector('[data-akb-main-shot] img');
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const image = thumb.querySelector('img');
        if (image && main) {
          main.src = image.currentSrc || image.src;
          main.alt = image.alt || main.alt;
        }
        thumbs.forEach((item) => item.setAttribute('aria-current', String(item === thumb)));
      });
    });

    const planRadios = section.querySelectorAll('input[name="selling_plan_option"]');
    const planWrapper = section.querySelector('[data-akb-plan-select-wrapper]');
    const planSelect = section.querySelector('[data-akb-plan-select]');
    planRadios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (radio.value === 'subscription') {
          if (planWrapper) planWrapper.hidden = false;
          if (planSelect) planSelect.disabled = false;
        } else {
          if (planWrapper) planWrapper.hidden = true;
          if (planSelect) planSelect.disabled = true;
        }
      });
    });

    const variantSelect = section.querySelector('[data-akb-variant]');
    if (!variantSelect) return;

    const price = section.querySelector('[data-akb-price]');
    const sku = section.querySelector('[data-akb-sku]');
    const stock = section.querySelector('[data-akb-stock]');
    const addButton = section.querySelector('[data-akb-add]');
    const quoteLink = section.querySelector('[data-akb-quote]');

    variantSelect.addEventListener('change', () => {
      const option = variantSelect.selectedOptions[0];
      const requiresQuote = option.dataset.quote === 'true';
      const isAvailable = option.dataset.available === 'true';
      const compareRaw = Number(option.dataset.compareRaw || 0);
      const priceRaw = Number(option.dataset.priceRaw || 0);

      if (price) {
        if (requiresQuote) {
          price.innerHTML = `<div class="big quote-price">${section.dataset.labelRequest}</div>`;
        } else if (compareRaw > priceRaw) {
          price.innerHTML = `<div class="big"><s>${option.dataset.compare}</s>${option.dataset.price}</div>`;
        } else {
          price.innerHTML = `<div class="big">${option.dataset.price}</div>`;
        }
      }
      if (sku) sku.textContent = option.dataset.sku;
      if (stock) {
        stock.textContent = isAvailable ? section.dataset.labelInStock : section.dataset.labelOutOfStock;
        stock.className = `chip ${isAvailable ? 'chip-ok' : 'chip-warn'}`;
      }
      if (addButton) addButton.hidden = requiresQuote || !isAvailable;
      if (quoteLink) {
        const params = new URLSearchParams({
          product: document.querySelector('.buy h1')?.textContent || '',
          sku: option.dataset.sku,
          variant: option.value
        });
        quoteLink.href = `${section.dataset.quoteBase}?${params.toString()}`;
      }
      if (option.dataset.image && main) main.src = option.dataset.image;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["akb-rfq-form"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-akb-rfq]').forEach((section) => {
    const form = section.querySelector('form');
    const productField = section.querySelector('[data-rfq-product]');
    const skuField = section.querySelector('[data-rfq-sku]');
    const params = new URLSearchParams(window.location.search);

    if (productField && params.get('product')) productField.value = params.get('product');
    if (skuField && params.get('sku')) skuField.value = params.get('sku');

    const success = section.querySelector('[data-akb-rfq-success]');
    if (success) success.focus();

    if (!form || !form.hasAttribute('data-custom-endpoint')) return;

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!form.reportValidity()) return;

      const files = Array.from(form.querySelector('input[type="file"]')?.files || []);
      const tooLarge = files.some((file) => file.size > 10 * 1024 * 1024);
      const status = form.querySelector('[data-akb-rfq-status]');
      const submit = form.querySelector('[data-akb-rfq-submit]');

      if (tooLarge) {
        status.textContent = section.dataset.fileError;
        status.focus();
        return;
      }

      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('RFQ request failed');
        form.reset();
        if (productField && params.get('product')) productField.value = params.get('product');
        if (skuField && params.get('sku')) skuField.value = params.get('sku');
        status.textContent = section.dataset.successMessage;
      } catch (error) {
        status.textContent = section.dataset.errorMessage;
      } finally {
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
        status.focus();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('[data-akb-nav]').forEach((nav) => {
    const button = nav.querySelector('[data-akb-mega]');
    const panel = nav.querySelector('[data-akb-mega-panel]');
    if (!button || !panel) return;

    const close = () => {
      panel.classList.remove('open');
      button.setAttribute('aria-expanded', 'false');
    };

    button.addEventListener('click', () => {
      const open = panel.classList.toggle('open');
      button.setAttribute('aria-expanded', String(open));
    });

    document.addEventListener('click', (event) => {
      if (!nav.contains(event.target)) close();
    });

    nav.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        close();
        button.focus();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
